import { Heart, Check, MessageCircle } from "lucide-react";
import { PRE_BRIDAL, GALLERY } from "@/data/salonData";
import { openWhatsApp, bookServiceMessage } from "@/lib/whatsapp";
import { Reveal } from "@/lib/useReveal";

export default function PreBridal() {
  return (
    <section
      id="prebridal"
      data-testid="prebridal-section"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#fff0f5] via-[#fff5f8] to-white" />

      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Visual */}
          <Reveal className="lg:col-span-5">
            <div className="relative grid grid-cols-2 gap-3">
              <div className="space-y-3">
                <div className="gallery-frame aspect-[3/4]">
                  <img src={GALLERY[7]} alt="Bridal" loading="lazy" />
                </div>
                <div className="gallery-frame aspect-square">
                  <img src={GALLERY[2]} alt="Bridal closeup" loading="lazy" />
                </div>
              </div>
              <div className="space-y-3 pt-8">
                <div className="gallery-frame aspect-square">
                  <img src={GALLERY[0]} alt="Bridal jewellery" loading="lazy" />
                </div>
                <div className="gallery-frame aspect-[3/4]">
                  <img src={GALLERY[6]} alt="Wedding day" loading="lazy" />
                </div>
              </div>
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 inline-flex items-center gap-2 px-4 py-2 rounded-full glass-pink shadow-md">
                <Heart size={14} className="text-[#b56477]" fill="#d98a99" />
                <span className="text-[10px] uppercase tracking-[0.25em] font-semibold text-[#b56477]">
                  Bridal Specialist
                </span>
              </div>
            </div>
          </Reveal>

          {/* Text + cards */}
          <div className="lg:col-span-7">
            <Reveal>
              <span className="heading-flourish">Pre-Bridal Packages</span>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2a1b18] font-medium mt-4 leading-[1.05]">
                For The <span className="text-gradient-rose italic">Bride</span> Who <br />
                Glows From Within
              </h2>
              <p className="mt-5 text-[#5c4642] text-base md:text-lg leading-relaxed">
                Begin your bridal journey weeks before the big day. Sessions
                designed to detox, nourish &amp; radiate.
              </p>
            </Reveal>

            <div className="mt-8 space-y-4">
              {PRE_BRIDAL.map((p, i) => (
                <Reveal key={p.name} delay={i * 100}>
                  <div
                    data-testid={`prebridal-card-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className={`relative card-lift bg-white rounded-2xl p-5 sm:p-6 ${
                      p.featured ? "border-2 border-[#d4af37]" : "border border-[#d98a99]/15"
                    }`}
                  >
                    {p.featured && (
                      <div className="absolute -top-3 right-5 px-3 py-1 rounded-full text-[10px] uppercase tracking-[0.2em] font-bold bg-[#d4af37] text-white">
                        Most Loved
                      </div>
                    )}
                    <div className="flex flex-col sm:flex-row sm:items-start gap-5 sm:gap-7">
                      <div className="flex-1">
                        <div className="font-display text-2xl text-[#2a1b18] font-semibold">
                          {p.name}
                        </div>
                        <div className="text-[#b56477] font-display text-3xl font-medium mt-1">
                          ₹{p.price.toLocaleString("en-IN")}
                        </div>
                        <ul className="mt-3 grid sm:grid-cols-2 gap-x-4 gap-y-1.5">
                          {p.highlights.map((h) => (
                            <li key={h} className="flex items-start gap-2 text-sm text-[#5c4642]">
                              <Check size={14} className="text-[#d4af37] mt-1 flex-shrink-0" />
                              {h}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <button
                        onClick={() =>
                          openWhatsApp(bookServiceMessage(p.name, p.price))
                        }
                        data-testid={`book-prebridal-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        className="btn-rose px-5 py-3 rounded-full text-sm font-medium inline-flex items-center justify-center gap-2 self-start sm:self-center whitespace-nowrap"
                      >
                        <MessageCircle size={14} />
                        Book Now
                      </button>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
